import { render, staticRenderFns } from "./platform-settlement-bind-sheet.vue?vue&type=template&id=5d2d46d4&scoped=true"
import script from "./platform-settlement-bind-sheet.vue?vue&type=script&lang=js"
export * from "./platform-settlement-bind-sheet.vue?vue&type=script&lang=js"
import style0 from "./platform-settlement-bind-sheet.vue?vue&type=style&index=0&id=5d2d46d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d46d4",
  null
  
)

export default component.exports